export default __webpack_public_path__ + "3dce92e649913d025102c14bf8f71455.png";